import { memo } from 'react';
import { CellProps } from '../../types';
import { CellEventsHandler } from '../formatters';
import { defaultHeaderRenderer } from '../headers';
import { IColumn } from '../types';

const Formatter = memo(function formatter(cellProps: CellProps) {
  return <CellEventsHandler cellProps={cellProps}>{cellProps.row.documentComplete || ''}</CellEventsHandler>;
});

export const DOCSColumn = (): IColumn => ({
  item: {
    key: 'documentComplete',
    name: 'Docs',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(104px, .5fr)',
    formatter: Formatter,
  },
  visible: ({ isDocsCountVisible }) => !!isDocsCountVisible,
});
